import React from "react";
import {TABLE_ICONS} from "../../constants/table/metadata/MaterialTableIcons";
import MaterialTable from "material-table";
import "./MaterialTable.css";

export default class TableForShipmentSummary extends React.Component {

    render() {
        const columns = this.props.columnMetadata;
        const data = this.props.results;

        return (
            <div>
                <MaterialTable
                    icons={TABLE_ICONS}
                    title="Aging Orders"
                    columns={columns}
                    data={data}
                    options={{
                        search: true,
                        headerStyle: {fontWeight: "bold", fontSize: 15},
                        exportButton: true,
                        exportAllData: true,
                        emptyRowsWhenPaging: false,
                        sorting: false,
                        draggable: false,
                        pageSizeOptions: [5, 10, 20, 40]
                    }}
                    style={{
                        marginLeft: "1em"
                    }}
                />
            </div>
        )
    }
}